import {
  useLocationHash,
  useLocationSearch,
  useNavigate,
} from '@rocketlane/rocket-router';
import { stringify } from 'query-string';
import { FC, useLayoutEffect } from 'react';
import { ProjectId, TaskIdV2 } from 'api/models';
import { createTransformer } from 'components/organisms/task-drawer/transformer';
import { useUser } from 'hooks/use-user';

export const TaskPaneHashRewrite: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const replace = useNavigate();
  const hash = useLocationHash();
  const search = useLocationSearch();
  const { user } = useUser();

  useLayoutEffect(() => {
    const groups = (hash ?? '').match(
      /.*task(?<project_id>\d+)!(?<task_id>\d+).*/,
    )?.groups;
    const project_id = parseInt(groups?.project_id ?? '', 10);
    const task_id = parseInt(groups?.task_id ?? '', 10);
    const open_approvals_tab = search.includes('tab=approvals');

    if (!Number.isNaN(project_id) && !Number.isNaN(task_id)) {
      replace(
        {
          search,
          hash: `${hash.replace(
            `task${project_id}!${task_id}`,
            stringify(
              createTransformer({ userType: user?.userType }).to([
                'show',
                ProjectId(project_id),
                TaskIdV2(task_id),
              ]),
            ),
          )}${open_approvals_tab ? '&task_drawer_tab=approvals' : ''}`,
        },
        { replace: true },
      );
    }
  }, [hash, search, replace, user?.userType]);

  return <>{children}</>;
};
